module.exports = __webpack_public_path__ + "static/imagem_7-0c47e1ea59364059add60ecd46475e4b.jpeg";